var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { AnalyticsEvent } from "@lonelyplanet/dotcom-analytics";
import * as Icon from "backpack-ui/dist/components/icon";
import * as cn from "classnames";
import * as React from "react";
import PhotoGallery from "../../../../shared/components/photoGallery";
import Portal from "../../../../shared/components/portal";
import heroImageSizes from "../../utils/heroImageSizes";
import Hero from "./hero";
import * as styles from "./styles.css";
var HeroGallery = /** @class */ (function (_super) {
    __extends(HeroGallery, _super);
    function HeroGallery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        _this.onClick = function () {
            _this.setState({
                isOpen: !_this.state.isOpen,
            });
        };
        return _this;
    }
    HeroGallery.prototype.render = function () {
        var _this = this;
        var _a = this.props, images = _a.images, _b = _a.imageSize, imageSize = _b === void 0 ? { height: 768, width: 1024 } : _b, className = _a.className, rest = __rest(_a, ["images", "imageSize", "className"]);
        return (React.createElement("div", __assign({ className: cn(styles.heroGallery, className) }, rest),
            images.slice(0, 3).map(function (image, index) {
                if (index === 0) {
                    return (React.createElement("div", { className: styles.heroGalleryPhoto, key: image },
                        React.createElement(Hero.Photo, { key: image, src: image, sizes: heroImageSizes.gallery.main })));
                }
                return (React.createElement("div", { className: styles.heroGalleryPhoto, key: image },
                    React.createElement(Hero.Photo, { key: image, src: image, sizes: heroImageSizes.gallery.thumbnail })));
            }),
            React.createElement(AnalyticsEvent, { render: function (track) { return (React.createElement("button", { className: styles.heroGalleryButton, onClick: function (e) {
                        track({
                            event: "hero gallery see all click",
                            "gtm.element": "HeroGallery",
                            "gtm.elementText": "See all " + images.length,
                        });
                        _this.onClick();
                    } },
                    React.createElement(Icon.Camera, { className: styles.heroGalleryButtonIcon }),
                    "See all ",
                    images.length)); } }),
            this.state.isOpen && (React.createElement(Portal, null,
                React.createElement(PhotoGallery, { items: Hero.mapImagesForPhotoGallery(images, imageSize), isOpen: this.state.isOpen, options: {}, onClose: this.onClick })))));
    };
    return HeroGallery;
}(React.Component));
export default HeroGallery;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/heroGallery.tsx
// module id = Rutb
// module chunks = 2